import { createAction, createReducer, PayloadAction } from '@reduxjs/toolkit'
import { SellContractFormData, SellContractRequestData } from 'src/helpers/sellContractFormValidation'

export interface InitialSellContractValues extends SellContractFormData {
  id: string
}

export interface SellContractReducer {
  loading: boolean
  error: string | null
  sell_contract_pdf: string | null
  initialSellContractValues: Record<string, InitialSellContractValues>
}

const initialState: SellContractReducer = {
  loading: false,
  error: null,
  sell_contract_pdf: null,
  initialSellContractValues: {}
}

export type CreateSellContractActionType = PayloadAction<SellContractRequestData>
export const CREATE_SELL_CONTRACT = createAction<SellContractRequestData>('sell_contract_reducer/create_sell_contract')
interface CreateSellContractSuccessPayload {
  pdf_url: string
}

export const CREATE_SELL_CONTRACT_SUCCESS = createAction<CreateSellContractSuccessPayload>(
  'sell_contract_reducer/create_sell_contract_success'
)
export const CREATE_SELL_CONTRACT_FAILURE = createAction('sell_contract_reducer/create_sell_contract_failure')

export const RESET_SELL_CONTRACT_PDF = createAction('sell_contract_reducer/reset_sell_contract_pdf')

interface FetchInitialSellContractValuesPayload {
  id: string
}

export type FetchInitialSellContractValuesActionType = PayloadAction<FetchInitialSellContractValuesPayload>

export const FETCH_INITIAL_SELL_CONTRACT_VALUES = createAction<FetchInitialSellContractValuesPayload>(
  'sell_contract_reducer/fetch_initial_sell_contract_values'
)

interface FetchInitialSellContractValuesSuccessPayload extends InitialSellContractValues {
  id: string
}

export const FETCH_INITIAL_SELL_CONTRACT_VALUES_SUCCESS = createAction<FetchInitialSellContractValuesSuccessPayload>(
  'sell_contract_reducer/fetch_initial_sell_contract_values_success'
)
export const FETCH_INITIAL_SELL_CONTRACT_VALUES_FAILURE = createAction(
  'sell_contract_reducer/fetch_initial_sell_contract_values_failure'
)

interface UpdateSellContractPayload {
  values: SellContractRequestData
  id: string
}

export type UpdateSellContractActionType = PayloadAction<UpdateSellContractPayload>
export const UPDATE_SELL_CONTRACT = createAction<UpdateSellContractPayload>(
  'sell_contract_reducer/update_sell_contract'
)
export const UPDATE_SELL_CONTRACT_SUCCESS = createAction<CreateSellContractSuccessPayload>(
  'sell_contract_reducer/update_sell_contract_success'
)
export const UPDATE_SELL_CONTRACT_FAILURE = createAction('sell_contract_reducer/update_sell_contract_failure')

export const sellContractReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(CREATE_SELL_CONTRACT, (state) => {
      state.loading = true
      state.error = null
    })
    .addCase(CREATE_SELL_CONTRACT_SUCCESS, (state, action) => {
      state.loading = false
      state.sell_contract_pdf = action.payload.pdf_url
      state.error = null
    })
    .addCase(CREATE_SELL_CONTRACT_FAILURE, (state) => {
      state.loading = false
    })
    .addCase(RESET_SELL_CONTRACT_PDF, (state) => {
      state.sell_contract_pdf = null
    })
    .addCase(FETCH_INITIAL_SELL_CONTRACT_VALUES, (state) => {
      state.loading = true
    })
    .addCase(FETCH_INITIAL_SELL_CONTRACT_VALUES_SUCCESS, (state, action) => {
      state.loading = false
      state.initialSellContractValues[action.payload.id.toString()] = action.payload
    })
    .addCase(FETCH_INITIAL_SELL_CONTRACT_VALUES_FAILURE, (state) => {
      state.loading = false
    })
    .addCase(UPDATE_SELL_CONTRACT, (state) => {
      state.loading = true
    })
    .addCase(UPDATE_SELL_CONTRACT_SUCCESS, (state, action) => {
      state.sell_contract_pdf = action.payload.pdf_url
      state.loading = false
    })
    .addCase(UPDATE_SELL_CONTRACT_FAILURE, (state) => {
      state.loading = false
    })
})
